import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Dialog = any & {
  showDialog: (title: string, message: string | TemplateRef<any>, style: string, actions: any, templateContext?: any) => void;
};
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  dialogContainer: Dialog;

  constructor() {}

  showDialog(
    title: string,
    message: string | TemplateRef<any>,
    style: string = 'default',
    actions: any,
    templateContext?: any
  ) {
    this.dialogContainer.showDialog(title, message, style, actions, templateContext);
  }

  registerDialogContainer(dialogContainer: Dialog) {
    this.dialogContainer = dialogContainer;
  }
}
